import { useLayoutEffect, useRef, type ReactNode } from "react";

/**
 * A bounded, independently scrolling surface for content whose height changes
 * between questions. Resetting before paint keeps every new question anchored
 * at its beginning without moving the surrounding page.
 */
export function QuestionStage({ identity, busy = false, className = "", children }: {
  identity: string;
  busy?: boolean;
  className?: string;
  children?: ReactNode;
}) {
  const stage = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (stage.current) stage.current.scrollTop = 0;
  }, [identity]);
  return <div ref={stage} className={`question-stage ${className}`.trim()} aria-busy={busy}>{children}</div>;
}
